exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stock-page[data-v-9f795dde] {\n  width: 100%;\n  height: 100%;\n}\n.stock-page .header[data-v-9f795dde] {\n  width: 100%;\n}\n.stock-page .header .header-title[data-v-9f795dde] {\n  color: #0B486B;\n  font-size: 32px;\n  font-weight: bold;\n  line-height: 39px;\n  margin-bottom: 20px;\n}", ""]);

// exports
